<template>
<div class="conteudo-sistema">
    <div class="fl-cabecalho">
        <div class="row animated slideInDown" style="margin-bottom:2em">
            <div class="col-6">
                <h4 style="margin-top:10px" class="animated slideInDown"><fa-icon icon="microchip"/> Processos</h4>
            </div>

            <div class="col-6">
            </div>
        </div>
    </div>

    <div v-if="status" class="row animated fadeIn" style="margin-bottom:2em">
        <div class="col-12 col-md-6 col-lg-4" style="margin-bottom:0.5em">
            <div class="card" style="min-height: 18em;">

                <div class="card-body">
                    <div class="text-left">
                        <h5 class="card-title text-info">
                            <fa-icon icon="clock" />  Processamento
                        </h5>
                    </div>

                    <hr/>

					<item-processamento
						:processando="status.salvaPosicao.salvando"
						:status="status.salvaPosicao.status"
						@ativaDesativaProcessamento="ativaDesativaProcessamento"
						:habilitado="status.salvaPosicao.habilitado"
						nome="SALVAMENTO"
						descricao="Salvando Posições..."
						:privilegio="38"

					 />

					<hr />

					<item-processamento
						:processando="status.processaPosicao.processando"
						:status="status.processaPosicao.status"
						@ativaDesativaProcessamento="ativaDesativaProcessamento"
						:habilitado="status.processaPosicao.habilitado"
						nome="PROCESSAMENTO"
						descricao="Processando Posições..."
						:privilegio="38"

					 />

					 <hr />

					<item-processamento
						:processando="status.processaFlightAware.processando"
						:status="status.processaFlightAware.status"
						@ativaDesativaProcessamento="ativaDesativaProcessamento"
						:habilitado="status.processaFlightAware.habilitado"
						nome="PROCESSAMENTO-FLIGHT-AWARE"
						descricao="Flight Aware API..."
						:privilegio="38"

					 />


                </div>
            </div>
        </div>

        <div class="col-12 col-md-6 col-lg-4" style="margin-bottom:0.5em">
             <div class="card" style="min-height: 18em;">
                <div class="card-body">
                    <div class="text-left">
                        <h5 class="card-title text-info">
                            <fa-icon icon="paper-plane" />  Envio
                        </h5>
                    </div>

                    <hr/>

					<item-processamento
						:processando="status.enviaPosicao.enviando"
						:status="status.enviaPosicao.status"
						@ativaDesativaProcessamento="ativaDesativaProcessamento"
						:habilitado="status.enviaPosicao.habilitado"
						nome="ENVIA-POSICAO"
						descricao="Enviando Posições..."
						:privilegio="38"

					 />

					<hr />

					<item-processamento
						:processando="status.enviaTrecho.enviando"
						:status="status.enviaTrecho.status"
						@ativaDesativaProcessamento="ativaDesativaProcessamento"
						:habilitado="status.enviaTrecho.habilitado"
						nome="ENVIA-TRECHO"
						descricao="Enviando Trechos..."
						:privilegio="38"

					 />

					<hr />

					<item-processamento
						:processando="status.enviaMensagem.enviando"
						:status="status.enviaMensagem.status"
						@ativaDesativaProcessamento="ativaDesativaProcessamento"
						:habilitado="status.enviaMensagem.habilitado"
						nome="ENVIA-MENSAGEM"
						descricao="Enviando Mensagens..."
						:privilegio="38"

					 />

					<hr />

					<item-processamento
						:processando="status.enviaManutencao.enviando"
						:status="status.enviaManutencao.status"
						@ativaDesativaProcessamento="ativaDesativaProcessamento"
						:habilitado="status.enviaManutencao.habilitado"
						nome="ENVIA-MANUTENCAO"
						descricao="Enviando Manutenção..."
						:privilegio="38"

					 />

					<hr />

					<item-processamento
						:processando="status.enviaNotificacao.enviando"
						:status="status.enviaNotificacao.status"
						@ativaDesativaProcessamento="ativaDesativaProcessamento"
						:habilitado="status.enviaNotificacao.habilitado"
						nome="ENVIA-NOTIFICACAO"
						descricao="Enviando Notificações..."
						:privilegio="38"

					 />
                </div>
            </div>
        </div>

        <div class="col-12 col-md-6 col-lg-4" style="margin-bottom:0.5em">
             <div class="card" style="min-height: 18em;">
                <div class="card-body">
                    <div class="text-left">

                        <h5 class="card-title text-info">
                            <fa-icon icon="calendar-day" /> Rotinas
                        </h5>
                     </div>

                    <hr/>

					<item-processamento
						:processando="status.rotina.renovandoRockSeven"
						:status="null"
						@ativaDesativaProcessamento="ativaDesativaProcessamento"
						:habilitado="status.rotina.habilitado"
						nome="ROTINAS"
						descricao="Renovando Rock7..."
						:privilegio="38"

					 />

					<item-processamento
						:processando="status.rotina.verificandoSemPosicao"
						:status="null"
						@ativaDesativaProcessamento="ativaDesativaProcessamento"
						:habilitado="status.rotina.habilitado"
						nome="ROTINAS"
						descricao="Verificando Sem Voo..."
						:privilegio="0"

					 />

                    <hr/>

                    <h6 class="text-info">Run at 19:00 UTC</h6>
                </div>
            </div>
        </div>
    </div>

    <!-- POSICOES NAO ENVIADAS -->
    <div class="row animated fadeIn" style="margin-bottom:2em">

        <div class="col-12" style="margin-bottom:0.5em">
            <div class="card text-center">
                <div class="card-body">
                    <div class="text-left">
                        <h5 class="card-title text-info">
                            <fa-icon icon="map-pin" /> Posições Não Enviadas
                        </h5>
                    </div>

                    <hr/>

                    <div class="row text-left" v-if="posicaoLista_.length == 0">
                        <div class="col-12">
                            <h4 class="text-success"> <fa-icon icon="check-circle" /> Nenhum erro encontrado.</h4>
                        </div>
                    </div>

                    <div v-for="item in posicaoLista_" :key="item.id">
                        <div class="row text-left">
                            <div class="col-lg-8 form-group" @click="item._exibir = !item._exibir; $forceUpdate()" style="cursor:pointer">
                                <fa-icon :icon="item._exibir? 'angle-down' : 'angle-up'" style="float:left; font-size:3em; margin-right: 0.2em;margin-top:0.05em" />
                                <h5><span class="badge badge-danger"> {{item.posicao.length}}
                                    {{item.posicao.length == 1 ? 'Posição' : 'Posições'}}</span> {{item.descricao}} <br/> <small>{{item.urlPosicao}}</small></h5>
                            </div>

                            <div class="col-lg-2 col-md-6 form-group">
                                <button v-if="_getPrivilegio(38)" @click="clickExcluir(item)" type="button" class="btn btn-block float-right btn-outline-danger"> <fa-icon :icon="['far', 'trash-alt']"  /> EXCLUIR</button>
                            </div>

                            <div class="col-lg-2 col-md-6 form-group">
                                <button type="button" @click="clickReenviar(item, 'P')" class="btn btn-block float-right btn-outline-primary"><fa-icon icon="paper-plane" />  REENVIAR</button>
                            </div>

                            <div class="col-12">
                                <hr />
                            </div>
                        </div>

                        <div class="row" style="z-index:0" v-if="item._exibir">
                            <div class="col-12">
                                <div class="table-responsive card card-table">
                                    <table class="table table-sm table-striped">
                                        <thead>
                                            <tr>
                                                <th>Data UTC</th>
                                                <th>IMEI</th>
                                                <th>Lat</th>
                                                <th>lng</th>
                                                <th>Direção</th>
                                                <th>Velocidade</th>
                                                <th>Movimento</th>
                                                <th>Altitude</th>
                                                <th>Google</th>
                                                <th>Trigger</th>
                                                <th>Source</th>
                                                <th>Temp</th>
                                                <th>Battery</th>
                                                <th>Alert Type</th>
                                                <th>transport</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="posicao in item.posicao" :key="posicao.id">
                                                <td v-html="posicao._data"></td>
                                                <td>{{posicao.imei}}</td>
                                                <td>{{posicao.lat}}</td>
                                                <td>{{posicao.lng}}</td>
                                                <td>{{posicao.direcao}}</td>
                                                <td>{{posicao.velocidade}}</td>
                                                <td>{{posicao.em_movimento}}</td>
                                                <td>{{posicao.altitude}}</td>
                                                <td>{{posicao.altitude_google}}</td>
                                                <td>{{posicao.trigger}}</td>
                                                <td>{{posicao.source}}</td>
                                                <td>{{posicao.temp}}</td>
                                                <td>{{posicao.battery}}</td>
                                                <td>{{posicao.alert_type}}</td>
                                                <td>{{posicao.transport}}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </div>

    <!-- TRECHOS NAO ENVIADAS -->
    <div class="row animated fadeIn" style="margin-bottom:2em">

        <div class="col-12" style="margin-bottom:0.5em">
            <div class="card text-center">
                <div class="card-body">
                    <div class="text-left">
                        <h5 class="card-title text-info">
                            <fa-icon icon="route" /> Trechos Não Enviados
                        </h5>
                    </div>

                    <hr/>

                    <div class="row text-left" v-if="trechoLista_.length == 0">
                        <div class="col-12">
                            <h4 class="text-success"> <fa-icon icon="check-circle" /> Nenhum erro encontrado.</h4>
                        </div>
                    </div>

                    <div v-for="item in trechoLista_" :key="item.id">
                        <div class="row text-left">
                            <div class="col-lg-8 form-group" @click="item._exibirTrecho = !item._exibirTrecho; $forceUpdate()" style="cursor:pointer">
                                <fa-icon :icon="item._exibirTrecho? 'angle-down' : 'angle-up'" style="float:left; font-size:3em; margin-right: 0.2em;margin-top:0.05em" />
                                <h5><span class="badge badge-danger"> {{item.trecho.length}} {{item.trecho.length == 1 ? 'Trecho' : 'Trechos'}}</span> {{item.descricao}} <br/> <small>{{item.urlTrecho}}</small></h5>
                            </div>

                            <div class="col-lg-2 col-md-6 form-group">
                                <button v-if="_getPrivilegio(38)" @click="clickExcluirTrecho(item)" type="button" class="btn btn-block float-right btn-outline-danger"> <fa-icon :icon="['far', 'trash-alt']"  /> EXCLUIR</button>
                            </div>

                            <div class="col-lg-2 col-md-6 form-group">
                                <button type="button" @click="clickReenviar(item, 'T')" class="btn btn-block float-right btn-outline-primary"><fa-icon icon="paper-plane" />  REENVIAR</button>
                            </div>

                            <div class="col-12">
                                <hr />
                            </div>
                        </div>

                        <div class="row" style="z-index:0" v-if="item._exibirTrecho">
                            <div class="col-12">
                                <div class="table-responsive card card-table">
                                    <table class="table table-sm table-striped">
                                        <thead>
                                            <tr>
                                                <th>Data UTC</th>
                                                <th>IMEI</th>
                                                <th>Acionamento UTC</th>
                                                <th>Decolagem UTC</th>
                                                <th>Pouso UTC</th>
                                                <th>Corte UTC</th>
                                                <th>Pousos UTC</th>
                                                <th>Gancho</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="trecho in item.trecho" :key="trecho.id">
                                                <td v-html="trecho._data"></td>
                                                <td>{{trecho.imei}}</td>
                                                <td>{{trecho._acionamento_utc}}</td>
                                                <td>{{trecho._decolagem_utc}}</td>
                                                <td>{{trecho._pouso_utc}}</td>
                                                <td>{{trecho._corte_utc}}</td>
                                                <td>{{trecho.pouso}}</td>
                                                <td>{{trecho.gancho}}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </div>



    <div class="row" style="margin-bottom:2em">
        <div class="col-12">
            <a href="#" @click.prevent="exibirJson = !exibirJson">
                <span v-if="!exibirJson">Exibir JSON</span>
                <span v-if="exibirJson">Esconder JSON</span>
            </a>
        </div>
        <div class="col-12" v-if="exibirJson">
        <pre>{{status}}</pre>
        </div>
    </div>

</div>
</template>

<script>
import _ from 'lodash'
import moment from 'moment'
import { mapState, mapActions } from 'vuex'
import axios from '../../routers/axios'
import itemProcessamento from './item-processamento.vue'
export default {

	components: {
		itemProcessamento
	},

    data () {
        return {
            status: false,
            exibirJson: false,
            desativar: false,
            servidores: [],
            posicoesNaoEnviadas: [],
        }
    },

    computed: {

		...mapState({
			webSocket: state => state.sessao.webSocket,
			sessao: state => state.sessao.user,
		}),

        posicaoLista_ () {
            return _.filter(this.servidores, s => { return s.posicao.length > 0})
        },

        trechoLista_ () {
            return _.filter(this.servidores, s => { return s.trecho.length > 0})
        }
	},

	watch: {
		webSocket (val) {
			if(val){
				this.carregaStatus()
				this.recebeStatus()
			}
		}
	},

    mounted (){

		if(this.webSocket){
            this.carregaStatus()
            this.recebeStatus()
		}

        this.carregaNaoEnviados()
    },

    methods: {

        carregaNaoEnviados(){
            axios.get(this._getUrl('api/servidorenvio')).then(response => {
                this.servidores = response.data.map(p => { p.posicao = []; p.trecho = []; return p})
                axios.get(this._getUrl('api/posicaoenvioerro')).then(response => {
                    this.servidores = this.servidores.map(item => {
                        item.posicao = []
                        item._exibir = false
                        item.posicao = _.filter(response.data, i => { return i.idServidorEnvio == item.id })
                        item.posicao = item.posicao.map(p => {
                            p._data = new moment(p.data_utc).format("DD/MM/YYYY <br/> HH:mm:ss")
                            // console.log(p)
                            return p

                        })
                        return item
                    })
                })

                axios.get(this._getUrl('api/trechoenvioerro')).then(response => {
                    this.servidores = this.servidores.map(item => {
                        item.trecho = []
                        item._exibirTrecho = false
                        item.trecho = _.filter(response.data, i => { return i.idServidorEnvio == item.id })
                        item.trecho = item.trecho.map(p => {
                            p._data = new moment(p.data_utc).format("DD/MM/YYYY HH:mm:ss")
                            p._acionamento_utc = new moment(p.acionamento_utc).format("DD/MM/YYYY HH:mm:ss")
                            p._decolagem_utc = new moment(p.decolagem_utc).format("DD/MM/YYYY HH:mm:ss")
                            p._pouso_utc = new moment(p.pouso_utc).format("DD/MM/YYYY HH:mm:ss")
                            p._corte_utc = new moment(p.corte_utc).format("DD/MM/YYYY HH:mm:ss")
                            // console.log(p)
                            return p

                        })
                        return item
                    })

                    // console.log(this.servidores)
                })
            })

            this.loop()
        },

        loop(){

            setTimeout(() => {
                this.carregaNaoEnviados()
            }, 60000)
        },

        recebeStatus(){

			$webSocket.on("UpdateStatusProcesso", (status) => {
				this.status = status
			});
        },



        ativaDesativaProcessamento(val, tipo){

            // ativa
            if(val.value){

				let post = {
					processo: tipo
				}

                this.$notify.loadIn('Ativando')
                axios.post(this._getUrl('api/processamento'), post).then(response => {
					// this.$notify.show('success','Processamento Ativado.')
                })
            } else {

                this.$notify.loadIn('Desativando')
				axios.delete(this._getUrl(`api/processamento/${tipo}`)).then(response => {
					// this.$notify.show('success','Processamento Desativado.')
                })
            }

        },

        clickReenviar(servidor, tipo){

            // posicao
            if(tipo == 'P'){
                let enviar = servidor.posicao.length

                for(var i in servidor.posicao){
                    this.$notify.loadIn('Reenviando')
                    axios.post(this._getUrl('api/posicaoenvioerro'), servidor.posicao[i]).then(response => {
                        enviar -= 1

                        if(enviar == 0){
							this.$notify.show('success','Posições reenviadas.')
                            this.carregaNaoEnviados()
                        }
                    })
                }
            }

            // trecho
            if(tipo == 'T'){
                let enviar = servidor.trecho.length

                for(var i in servidor.trecho){
                    this.$notify.loadIn('Reenviando')
                    axios.post(this._getUrl('api/trechoenvioerro'), servidor.trecho[i]).then(response => {
                        enviar -= 1

                        if(enviar == 0){
							this.$notify.show('success','Trechos reenviados.')
                            this.carregaNaoEnviados()
                        }
                    })
                }
            }


        },

        clickExcluir(servidor){

			let text = `<h4>Deseja excluir posições desse servidor?</h4>
						<br>
						<p class="text-danger">
							${servidor.descricao}
						</p>`

			this.$modalExcluir.show(text, servidor).then(item => {
				this.excluir(item)
			})
        },

        excluir(servidor){

            let enviar = servidor.posicao.length

            for(var i in servidor.posicao){
                this.$notify.loadIn('Excluindo')
                axios.delete(this._getUrl('api/posicaoenvioerro') + '/' + servidor.posicao[i].id_posicao_envio).then(response => {
                    enviar -= 1

                    if(enviar == 0){
						this.$notify.show('success','Posições excluídas.')
                        this.carregaNaoEnviados()
                    }
                })
            }
        },

        clickExcluirTrecho(servidor){

			let text = `<h4>
							Deseja excluir trechos desse servidor?
						</h4>
						<br>
						<p class="text-danger">
							${servidor.descricao}
						</p>`

			this.$modalExcluir.show(text, servidor).then(item => {
				this.excluirTrecho(item)
			})
        },

        excluirTrecho(servidor){

            let enviar = servidor.trecho.length

            for(var i in servidor.trecho){
                this.$notify.loadIn('Excluindo')
                axios.delete(this._getUrl('api/trechoenvioerro') + '/' + servidor.trecho[i].id).then(response => {
                    enviar -= 1

                    if(enviar == 0){
						this.$notify.show('success','Trechos excluídos.')
                        this.carregaNaoEnviados()
                    }
                })
            }
        },

        carregaStatus(){

            $webSocket.invoke("GetStatus", this.sessao.token).then(status => {
                //console.log("status", status)
                if (!_.isNil(status)) {
                    this.status = status
                }
            }).catch(err => {
                console.warn("erro websoket", err.toString());
            });
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/views/processamento/main.vue